import { GovernmentDocumentsTable } from "@/components/government-documents/government-documents-table";
import { createFileRoute } from "@tanstack/react-router";

function GovernmentDocumentsPage() {
  return <GovernmentDocumentsTable />;
}

export const Route = createFileRoute(
  "/_authenticated/website/government-documents/",
)({
  component: GovernmentDocumentsPage,
});
